import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take, timeout } from 'rxjs/operators';
import { SiteDataService } from '../services/site-data.service';

@Injectable({
	providedIn: 'root'
})
export class MfaEnrollmentGuard implements CanActivate {
	private siteData = inject(SiteDataService);
	private router = inject(Router);

	private static readonly SESSION_WAIT_MS = 5000;

	// Deep-link hardening only. The shell-level interstitial is the load-bearing display and renders
	// over any route; this guard stops a walled user from activating a feature route's components
	// (and firing gated XHRs) by keeping them on the landing route while non-compliant.
	canActivate(): Observable<boolean> {
		return this.siteData.loggedInUser$.pipe(
			take(1),
			// loggedInUser$ only emits once the session resolves. If the session fetch never
			// resolves, allow navigation rather than hanging it forever — enforcement still holds via
			// the shell interstitial and the server-side mfa_enrollment_required 403.
			timeout(MfaEnrollmentGuard.SESSION_WAIT_MS),
			map(session => {
				if (session?.mfaEnrollmentRequired) {
					this.router.navigate(['/admin/dashboard']);
					return false;
				}
				return true;
			}),
			catchError(() => of(true))
		);
	}
}
